import { useQuery } from "@tanstack/react-query";

import { getFieldCropRecommendations, getFieldCropRecommendationsSimulations } from "services";

import { GET_FIELDS_CROP_RECOMMENDATIONS } from "consts";

import { FieldCropRecommendationsResponse } from "models";

export const useGetFieldCropRecommendations = ({ fieldIds, enabled, simulationIds }: { fieldIds: string[]; enabled?: boolean; simulationIds?: string[] }) =>
  useQuery<FieldCropRecommendationsResponse>({
    queryKey: [GET_FIELDS_CROP_RECOMMENDATIONS, fieldIds, simulationIds],
    queryFn: ({ signal }) => (simulationIds ? getFieldCropRecommendationsSimulations({ simulationIds, signal }) : getFieldCropRecommendations({ fieldIds })),
    enabled,
  });
